import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Bugraphs } from "../components/Builders/Bugrafx/Bugraphs";
import { getDataUser, setTemporalUsers } from "../libs/redux/slices/authSlice/authSlice";
import { useGetGraphsQuery } from "../libs/redux/slices/Graficsx/graficsxApiSlice";
import { useGetUserTemporalQuery, useGetDashboardQuery, useGetTurnsTodayByUserQuery } from "../libs/redux/slices/authSlice/authApiSlice";
import { TableLoader, BoxStatus, ShiftBanner, Box, TrafficLightModal } from "codekit";
import { setInitialFilter } from "../libs/redux/slices/Graficsx/Criticid/criticidSlice";
import { useGetQuantityCriticalQuery } from "../libs/redux/slices/Graficsx/Criticid/criticidApiSlice";

function DashboardHome() {
  const dispatch = useDispatch();
  const { USRIDXXX, CARIDXXX, USRNOMXX } = useSelector(getDataUser);
  const { data: graphs } = useGetGraphsQuery({ USRIDXXX, CARIDXXX });
  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });
  const { data: temporalUsers, isSuccess } = useGetUserTemporalQuery({ USRIDXXX });
  const [banner, setBanner] = React.useState(null);
  const { data: dataGraphics, isSuccess: isSuccessGraphics } = useGetDashboardQuery();
  const graphics = ["TASKGRAF", "CARXTEAM", "INGEPROP", "OPESNFAC", "ALETELEG", "ALEDOCXX", "USERTURX", "INVSINDO"]
  const graphicsTurn = ["NOTITURN"];
  const [isOpen, setIsOpen] = useState(true)
  const criticidRef = useRef(null);
  const [isCritical, setIsCritical] = useState(false)
  const { data: criticalOperations, isSuccess: isSuiccessCritical } = useGetQuantityCriticalQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );
  const [quantityCritical, setQuantityCritical] = useState(0)

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  const fmtHour = (d) =>
    d.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true });


  //Hook para el seteo de los usuarios reemplazo
  useEffect(() => {
    if (isSuccess) {
      const { data = [] } = temporalUsers;
      dispatch(setTemporalUsers(data));
    }
  }, [isSuccess, temporalUsers, dispatch]);

  //Hook para validar si se encontraron operaciones criticas
  useEffect(() => {
    if (isSuiccessCritical) {
      const { data = {} } = criticalOperations;
      if (Object.keys(data).length > 0) {
        setIsCritical(true)
        setQuantityCritical(data["ROJO"].total)
      }
    }
  }, [isSuiccessCritical, criticalOperations])

  React.useEffect(() => {
    const compute = () => {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t => (t.RANGESXX ?? []).map(r => ({
          start: toDateAt(dateStr, r.STARTXXX),
          end: toDateAt(dateStr, r.ENDXXXXX),
        })))
        .sort((a, b) => a.start - b.start);

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        setBanner({
          visible: true,
          variant: 'end',
          primary: `Tu turno termina a las ${fmtHour(current.end)}`,
          secondary: 'Recuerda finalizar tu turno en la opción Cerrar Turno',
        });
        return;
      }

      const next = ranges.find(r => now < r.start);
      if (next) {
        setBanner({
          visible: true,
          variant: 'start',
          primary: `Tu turno inicia a las ${fmtHour(next.start)}`,
          secondary: `Hoy (${dayData.DAYXXXXX}). Recuerda finalizar tu turno en la opción Cerrar Turno`,
        });
        return;
      }

      setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
    };

    compute();
    const id = setInterval(compute, 5 * 60 * 1000); // 5 minutos
    return () => clearInterval(id);
  }, [turnsByUser]);

  if (!isSuccessGraphics || !graphs) {
    return <BoxStatus variant="loading" text="Cargando información..." />;
  }
  const hasBugraphs = dataGraphics.data.some(
    (item) => graphics.includes(item.GRACOMXX)
  );
  const hasTurns = dataGraphics.data.some(
    (item) => graphicsTurn.includes(item.GRACOMXX)
  );
  const otherComponents = dataGraphics.data.filter(
    (item) => !graphics.includes(item.GRACOMXX)
  );

  //Funcion redirigir la dashboard de operaciones criticas
  const handleClickPopup = (color) => {
    setIsOpen(false)
    dispatch(setInitialFilter(color))
    setTimeout(() => {
      criticidRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 300)
  }

  return (
    <>
      {/**Criticidad operacion */}
      {isCritical && (
        <TrafficLightModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title={`Bienvenid@ ${USRNOMXX}`}
          subtitle="Tienes"
          bottomText="OPERACIONES CRÍTICAS"
          bgColor="error-500"
          onClick={() => handleClickPopup("ROJO")}
        >
          {quantityCritical}
        </TrafficLightModal>
      )}
      {hasTurns && banner?.visible && (
        <Box spacing={5}>
          <ShiftBanner
            variant={banner.variant}
            srcBgImage="/images/cima-icon.png"
            primaryText={banner.primary}
            secondaryText={banner.secondary}
            alignment="left"
            imageRotation={-10}
            imageX={95}
          />
        </Box>
      )}
      {hasBugraphs && <Bugraphs graphs={graphs.data} />}
      {otherComponents.map((CIMS0036, index) => {
        const CurrentGraphic = lazy(() =>
          import(`../components/${CIMS0036.GRACOMXX}`).catch((error) => {
            return { default: () => null };
          })
        );
        const isCriticid = CIMS0036.GRACOMXX === 'Criticid'

        return (
          <Suspense fallback={<TableLoader />} key={index}>
            <div ref={isCriticid ? criticidRef : null}>
              <CurrentGraphic />
            </div>
          </Suspense>
        );
      })}
    </>
  );
}

export default DashboardHome;
